module.exports = __webpack_public_path__ + "static/media/logo_azul.1d05d3fe.png";